// extracted by mini-css-extract-plugin
export default {"wrapper":"_uw7lX"};